"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propsMain = _interopRequireDefault(require("@/components/wl-component-gallery/wl-list/mixins/props-main"));
var _propsMain2 = _interopRequireDefault(require("./props-main"));
var _default = exports.default = [_propsMain.default, _propsMain2.default];